import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { UiModalDefaultComponent } from '../../../../../shared/dashboard/ui-modal-default/src/lib/ui-modal-default.component';
import { EmployeesService } from '../../services/employees/employees.service';
import { SalaryAdvanceService } from '../../services/salary-advance/salary-advance.service';
import { DataAccessOrganizationsService } from '@unico-people/shared/dashboard/data-access-organizations';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Component({
  selector: 'unico-people-employee-profile',
  templateUrl: './employee-profile.component.html',
  styleUrls: ['./employee-profile.component.scss']
})
export class EmployeeProfileComponent implements OnInit {
  position: any;

  uuid: string;
  unit: string;
  account: string;
  esocial: Number;
  advanceSalaryServiceId: string;
  isColaboratorModule: boolean;

  blockButtonLabel: any;
  isBlocked: boolean;
  hasEmployeeBenefits: boolean;
  dialogDefault: MatDialogRef<UiModalDefaultComponent>;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    public employeesService: EmployeesService,
    private salaryAdvanceService: SalaryAdvanceService,
    private dataAccessOrganizations: DataAccessOrganizationsService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.uuid = params.p;
      this.account = params.a;
    });

    this.router.navigate([], {
      queryParams: {
        'a': null,
      },
      queryParamsHandling: 'merge'
    });

    this.loadEmployeeInfos();
    this.loadServicesByEmployee();

    if (this.account) {
      SessionStorage.setItem('currentAccount', this.account);
      this.dataAccessOrganizations.sendAccount(
        this.dataAccessOrganizations.setOrganization(this.account)
      );
    }
  }

  loadEmployeeInfos(): void {
    this.employeesService.getEmployee(this.uuid).pipe(
      catchError(err => of(err))
    ).subscribe(res => {
      this.position = res.data;
      if (this.position) {
        SessionStorage.setItem('collaborator', {
          name: this.position.name,
          email: this.position.email,
          cpf: this.position.identificatorType == 'cpf' ? this.position.identificator : '',
          phoneNumber: this.position.phone,
          active: this.position.active,
        });
      }
    });
  }

  loadServicesByEmployee(): void {
    this.employeesService
      .getEmployeeServices(this.uuid)
      .pipe(
        tap(res => (this.hasEmployeeBenefits = res.data ? true : false)),
        map(res => res.data),
        tap(data => this.setBlockButton(data[0])),
        catchError(err => of(err))
      )
      .subscribe();
  }

  onDeactivate(): void {
    window.scrollTo(0, 0);
  }

  unBlockSalaryAdvance(): void {
    this.dialogDefault = this.dialog.open(UiModalDefaultComponent, {
      disableClose: false
    });

    this.dialogDefault.componentInstance.confirmMessage = this.blockButtonLabel.title;
    this.dialogDefault.componentInstance.menssageSubtitle = this.blockButtonLabel.info;
    this.dialogDefault.componentInstance.confirmMessageButton = this.blockButtonLabel.label;

    this.dialogDefault.afterClosed().subscribe(success => {
      if (success) {
        this.salaryAdvanceService.unBlockAdvanceSalary(this.advanceSalaryServiceId).subscribe(() => this.loadServicesByEmployee());
      }
    });
  }

  setBlockButton(data): void {
    const activeAdvanceSalary = data.status === 1 ? true : false;
    this.advanceSalaryServiceId = data.id;

    if (!activeAdvanceSalary) {
      this.isBlocked = true;
      this.blockButtonLabel = {
        label: 'Desbloquear',
        slug: 'blocked',
        title: 'Tem certeza que deseja desbloquear este colaborador?',
        info: 'Ao desbloquear este colaborador, ele terá acesso novamente aos benefício' + ' de de antecipação salarial.'
      };
      return;
    }
    this.isBlocked = false;
    return;
  }
}
